import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    // Clear the hash so it isn't reprocessed
    window.history.replaceState({}, document.title, window.location.pathname);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.error("Auth failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="flex items-center gap-3 text-zinc-400 font-mono text-sm uppercase tracking-widest">
        <Loader2 className="w-4 h-4 animate-spin" />
        Establishing session...
      </div>
    </div>
  );
}
